import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { DoublePanelViewLayout } from 'layouts/DoublePanelViewLayout'
import useQueryParams from 'utils/hooks/useQueryParams'
import LinkForm from 'modules/Forms/Referral/LinkForm'
import { useFinancialTerms } from 'modules/Referral/ReferralLinks/hooks/useFinancialTerms'
import { toFixedIfNecessary } from 'utils/toFixedIfNecessary'

const CreateLink = () => {
  const pathGen = useGeneratePathI18n()
  const history = useHistory()
  const { fetchTerms } = useFinancialTerms()
  const [settings, setSettings] = useState([])
  const {
    query: { goBack },
  } = useQueryParams()

  useEffect(
    () =>
      fetchTerms().then(({ data }) => {
        setSettings(
          data.reduce(
            (
              acc,
              { adnetwork, financial_profile_type_alias, total_percent },
              index,
            ) => {
              const partnerPercent = (total_percent * 50) / 100
              const clientPercent = total_percent - partnerPercent

              return [
                ...acc,
                {
                  financial_profile_type_alias,
                  client_percent: +toFixedIfNecessary(clientPercent),
                  partner_percent: +toFixedIfNecessary(partnerPercent),
                  total_percent: +total_percent,
                  adnetwork,
                  index,
                },
              ]
            },
            [],
          ),
        )
      }),
    [],
  )

  return (
    <DoublePanelViewLayout
      onClose={(e) => {
        e.preventDefault()
        history.push(goBack ?? pathGen(ROUTES.REFERRAL_LINKS))
      }}
    >
      <LinkForm
        settings={settings}
        onClose={() => history.push(goBack ?? pathGen(ROUTES.REFERRAL_LINKS))}
      />
    </DoublePanelViewLayout>
  )
}

export default CreateLink
